import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import {setCookie, getCookie} from "cookies-next";
import Srcset from "@/components/common/Srcset";
import styles from "../GeneralFeedbackIcon/GeneralFeedbackIcon.module.scss";

export default function GeneralFeedbackIcon() {
  const [isVisible, setIsVisible] = useState(false);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  useEffect(() => {
    const feedbackHidden = getCookie("feedback");
    if(!feedbackHidden) {
      setIsVisible(true);
    }
  },[]);

  const handleClose = () => {
    setIsVisible(false);
    setCookie("feedback", "true", { maxAge: 172800 }); // Set cookie to expire in 48 hours
  };

  const handleRedirect = () => {
    if (isPWA) {
      window.open("https://form.typeform.com/to/gRuqlvMo", "_self"); // Redirect to the feedback form - Opens in the same tab
    } else {
      window.open("https://form.typeform.com/to/gRuqlvMo", "_blank"); // Redirect to the feedback form - Opens in a new tab
    }
    handleClose(); // Close the feedback button after redirecting
  };

  if(!isVisible) return null;

  return (
    <>
      <div tabIndex={0} className={`gn_feedback_button x-small-md x-small-sm x-small-xs light ${styles.feedback_button}`} role="button" onClick={handleRedirect}>
        Feedback
      </div>
    </>
  );
}